import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { CourierService, CourierSettingsOutput } from 'core/http/project/courier/courier.service';
import { ownedError } from 'core/utils/owned-error';
import { Observable } from 'rxjs';

@Injectable()
export class CourierSettingResolver {
  constructor(private courierService: CourierService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<CourierSettingsOutput> {
    const courierId = route.params.courierId;
    if (!courierId) {
      throw ownedError(new Error('Courier ID is missing'));
    }
    return this.courierService.getCourierSetting(courierId);
  }
}
